module.exports={account_link_complete_message:"已成功绑定NEXON账号。"};